import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Hint, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

import theme from '@/styles/theme';

export const ROLLOVER_HINT_TEXT = 'Your plan offers rollover. Refer to your plan documents to see if the rollover applies to you.';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  &:hover {
    fill: ${theme.colors.iconAccent};
  }
  transition: fill 0.3s;
`;

export const RolloverHint: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box justify="center" align="center" width={{ min: '16px'}}>
      <Hint
        hintAlign="right"
        hintWidth={184}
        hintElement={(
          <StyledInfoIcon
            color="iconSecondary"
            size="16px"
            style={{ marginTop: theme.spacings.xxxs }}
          />
        )}
      >
        <Inscription size='12px' weight={500}>
          {t(ROLLOVER_HINT_TEXT)}
        </Inscription>
      </Hint>
    </Box>
  );
};
